// config.js
// Single place for API URL
// npm start     → uses .env.development → http://80.225.197.31:8003
// npm run build → uses .env.production  → https://trading.edunol.org/api

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8002';

export default API_BASE;